import authActions from "./auth";

export const useActions = (state, dispatch) => ({
  ...authActions(state, dispatch),
});
